const setSession = (session) => {
  return {
    type: "SET_SESSION",
    session
  }
}

export {
  setSession
}